import { getCookie, setCookie } from './cookies';

export type IntervalPref = '60m' | '15m';

export interface UserPrefs {
  providerId?: string;
  includeTaxes?: boolean;
  interval?: IntervalPref;
  regionId?: string;
}

export const PREF_COOKIE_NAME = 'epx_prefs';

export function readPrefsFromCookie(): UserPrefs | null {
  const raw = getCookie(PREF_COOKIE_NAME);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as UserPrefs;
    const prefs: UserPrefs = {};
    if (parsed && typeof parsed === 'object') {
      if (typeof parsed.providerId === 'string') prefs.providerId = parsed.providerId;
      if (typeof parsed.includeTaxes === 'boolean') prefs.includeTaxes = parsed.includeTaxes;
      if (parsed.interval === '60m' || parsed.interval === '15m') prefs.interval = parsed.interval;
      if (typeof parsed.regionId === 'string') prefs.regionId = parsed.regionId;
    }
    return Object.keys(prefs).length ? prefs : null;
  } catch {
    return null;
  }
}

export function writePrefsToCookie(prefs: UserPrefs): void {
  try {
    const value = JSON.stringify(prefs);
    setCookie(PREF_COOKIE_NAME, value, { days: 365, sameSite: 'Lax' });
  } catch {
    // ignore
  }
}
